module.exports = __webpack_public_path__ + "img/luminarium.f9cc9004.webp";